import { createReducer } from "@reduxjs/toolkit";
import * as actionTypes from "~/store/action_types";

const assignees = createReducer({}, (builder) => {
  builder
    .addCase(actionTypes.EDIT_TASK_LOADING, (state, action) => {
      const { taskId = 0, attributes = {}, _multiple_assignees = false } = action;
      if (!_multiple_assignees) {
        return state;
      }
      if (attributes && Array.isArray(attributes.assignee_ids) && taskId && state[`Task-${taskId}`]) {
        state[`Task-${taskId}-previous`] = { ...state[`Task-${taskId}`] };
        const user_ids = attributes.assignee_ids;
        state[`Task-${taskId}`] = {};

        if (user_ids.length) {
          user_ids.forEach((userId, index) => {
            state[`Task-${taskId}`][index] = {
              id: index,
              user_id: userId,
              parent_id: taskId,
              parent_type: "Task",
              estimate: 0,
              job_type_id: 0,
              is_split: false,
              pending: true,
            };
          });
        }
      }
      return state;
    })
    .addCase(actionTypes.EDIT_TASK_ERROR, (state, action) => {
      const { taskId = 0, _multiple_assignees = false } = action;
      if (!_multiple_assignees) {
        return state;
      }
      if (taskId && state[`Task-${taskId}-previous`]) {
        state[`Task-${taskId}`] = { ...state[`Task-${taskId}-previous`] };
        delete state[`Task-${taskId}-previous`];
      }
      return state;
    })
    .addMatcher(
      (action) => [actionTypes.LOAD_TASK, actionTypes.EDIT_TASK_SUCCESS].includes(action.type),
      (state, action) => {
        const { response = {}, taskId = 0, _multiple_assignees = false } = action;
        if (!_multiple_assignees) {
          return state;
        }
        if (taskId) {
          if (state[`Task-${taskId}-previous`]) {
            delete state[`Task-${taskId}-previous`];
          }
          const { entities = {} } = response;
          const { assignees = {} } = entities;
          state[`Task-${taskId}`] = { ...assignees };
        }
        return state;
      }
    );
});

export default assignees;
